import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { selfcreditService } from '../self-credit.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-otp-doc',
  templateUrl: './otp-doc.component.html',
  styleUrls: ['./otp-doc.component.scss']
})

export class OtpDocComponent implements OnInit {
  id: string;
  requestId: string;
  createCreditForm!: UntypedFormGroup;
  isLoading: boolean = true;
  isSuccess: boolean = false;
  isValidated: boolean = false;
  documentsArray: any[] = [];

  constructor(
    private route: ActivatedRoute, 
    private formBuilder: UntypedFormBuilder, 
    public service: selfcreditService
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.requestId = this.route.snapshot.paramMap.get('requestId');

    this.createCreditForm = this.formBuilder.group({
      documents: [null, Validators.required],
      authorize: [false, Validators.requiredTrue],
    });

    this.checkStatus();
  }

  checkStatus() {
    this.isLoading = true;
    this.service.getRequestStatus(this.requestId).subscribe({
      next: (reps: any) => {
        this.isLoading = false;
        if (reps.applicationStatus !== 0) {
          this.isValidated = true;
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error fetching status', err);
      }
    });
  }

  onFileSelected(event: any): void {
    const selectedFiles: FileList = event.target.files;
    const fileArray: File[] = Array.from(selectedFiles);
    this.convertAndSendFiles(fileArray);
  }

  convertAndSendFiles(files: File[]) {
    const base64Array: any[] = [];
    for (const file of files) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64String: string = e.target.result;
        let partes: string[] = base64String.split(',');
        base64Array.push({
          id: 0,
          name: file.name,
          url: 's',
          content: partes[1],
        });

        if (base64Array.length === files.length) {
          this.uploadFiles(base64Array);
        }
      };
      reader.readAsDataURL(file);
    }
  }

  uploadFiles(files): void {
    this.createCreditForm.controls['documents'].setValue(files);
  }

  saveDocuments() {
    if (this.createCreditForm.invalid) {
      Swal.fire('Atención', 'Por favor completa todos los campos requeridos', 'warning');
      return;
    }

    const documents = this.createCreditForm.get('documents').value;
    if (!documents || documents.length === 0) {
      Swal.fire('Error', 'Por favor selecciona un documento', 'error');
      return;
    }

    const unifiedExtraData = {
      ...documents[0],
      customerId: this.id,
      requestId: this.requestId
    };

    this.isLoading = true;
    this.service.saveDocCredit(unifiedExtraData).subscribe({
      next: (resp: any) => {
        this.isLoading = false;
        if (resp.success) {
          this.isSuccess = true;
          Swal.fire('¡Éxito!', 'Documento cargado correctamente', 'success');
        } else {
          Swal.fire('Error', resp.error || 'No se pudo guardar el documento', 'error');
        }
      },
      error: (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No pudimos realizar el registro, intenta nuevamente'
        });
      }
    });
  }
}
